module.exports = __webpack_public_path__ + "static/media/SuddenlyaMurderBookJacket.61e7a3ca.jpg";